<template>
  <div class="scoring-table-list">
    <div class="filter">
      <div class="title">
        <div class="title-left" @click="changeActive(1)">{{fieldName}} <van-icon name="play" class="play-icon" :class="{'active': active === 1}" /></div>
        <div class="title-right" @click="changeActive(2)">{{dateName}} <van-icon name="play" class="play-icon" :class="{'active': active === 2}" /></div>
        <div class="title-right" @click="changeActive(3)">{{type}} <van-icon name="play" class="play-icon" :class="{'active': active === 3}" /></div>
      </div>
      <div class="overlay" ref="overlay" :class="{'bg-active':active !== 0 }" @click.prevent="changeActive(active)">
        <div v-if="active === 1">
          <div class="overlay-list" :class="{'list-active': active !== 0 }">
            <div class="overlay-item" :class="{'active': fieldId == i.id}" v-for="i in columns" :key="i.id" @click="changeField(i)">{{i.name}}</div>
          </div>
        </div>
        <div v-if="active === 2">
          <div class="overlay-list" :class="{'list-active': active !== 0 }">
            <div class="overlay-item" :class="{'active': dateName == i.beginDate}" v-for="i in gameDateList" :key="i.beginDate" @click="changeDate(i)">{{i.beginDate}}</div>
          </div>
        </div>
        <div v-if="active === 3">
          <div class="overlay-list" :class="{'list-active': active !== 0 }">
            <div class="overlay-item" :class="{'active': type == i.name}" v-for="i in typeList" :key="i.name" @click="changeType(i)">{{i.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="list">
        <div class="item" v-for="item in filteredList" :key="item.id" @click="goDetail(item)">
          <div class="flex-center match-title">
            <span>{{item.group}}</span>
            <span>{{ item.name }}</span>
          </div>
          <div class="info flex-center">
            <div class="status">
              <div class="time">
                <span v-if="item.beginDate && item.endDate">{{getDate(item.beginDate, '{h}:{i}')}} - {{getDate(item.endDate, '{h}:{i}')}}</span>
                <span v-else style="color: #5f5f5f;">未设置</span>
              </div>
              <div class="status-text">
                <span v-if="item.fieldLiveRoomStatus === 3">已结束</span>
                <span v-else-if="item.fieldLiveRoomStatus < 0" style="color: #A7A7A7;">未开始</span>
                <span v-else style="color: #0D9512;">进行中</span>
              </div>
            </div>
            <div class="name">
              <div>
                <span v-if="item.homeTeamName">{{ item.homeTeamName}}</span>
                <span v-else style="color: #5f5f5f;">待定</span>
              </div>
              <div>
                <span v-if="item.awayTeamName">{{ item.awayTeamName}}</span>
                <span v-else style="color: #5f5f5f;">待定</span>
              </div>
            </div>
            <div class="score">
              <div>{{ item.homeScore !== -1 ? item.homeScore : '-' }}</div>
              <div>{{ item.awayScore !== -1 ? item.awayScore : '-' }}</div>
            </div>
          </div>
        </div>
        <div class="empty" v-if="filteredList.length === 0" style="background: #fff;">
          <van-empty description="暂无数据" />
        </div>
      </div>
    </van-pull-refresh>

    <!-- 设置对阵 -->
    <van-popup v-model="showSetTeam" position="bottom">
      <div class="set-match">
       <div class="set-match-title flex-center">
        <div class="cancel" @click="cancelSetTeam">取消</div>
        <div class="title">设置对阵</div>
        <div class="confirm" @click="confirmSetTeam">确定</div>
      </div>
      <div class="set-match-content flex-center">
        <div class="input">
          <div class="flex-center" style="height: 100%;"  @click="updateTeamIndex(1)">
            <span v-if="!homeName" style="color: #5f5f5f;">请选择选手</span>
            <span v-else>{{homeName}}</span>
            <van-icon name="arrow-down" class="arrow-down" />
          </div>

          <div class="input-list" :class="{'list-active': teamIndexActive === 1}">
            <div class="input-item" v-for="t in teamList" :key="t.id" @click="setTeam(t,'home')" :class="{'active': t.id == setTeamObj.homeTeamId, 'disabled': (t.is && t.id !== setTeamObj.homeTeamId) || isDisabled('home', t.id)}">{{t.name}}</div>
          </div>
        </div>
        <div class="vs">VS</div>
        <div class="input">
          <div class="flex-center" style="height: 100%;"  @click="updateTeamIndex(2)">
            <span v-if="!awayName" style="color: #5f5f5f;">请选择选手</span>
            <span v-else>{{awayName}}</span>
            <van-icon name="arrow-down" class="arrow-down" />
          </div>

          <div class="input-list" :class="{'list-active': teamIndexActive === 2}">
            <div class="input-item" v-for="t in teamList" :key="t.id" @click="setTeam(t,'away')" :class="{'active': t.id == setTeamObj.awayTeamId, 'disabled': (t.is && t.id !== setTeamObj.awayTeamId) || isDisabled('away', t.id)}">{{t.name}}</div>
          </div>
        </div>
      </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { adminGetUnionMatchFields,getUnionMatchFieldGameDateList,adminGetUnionMatchFieldGameList } from '@/api/match-team-game'
import { adminGetBMMatchStageTeamList,adminUpdateBMMatchGame,adminGetBMUnionMatchGameList } from '@/api/match'
import Vue from 'vue'
import { Popup, PullRefresh, Toast, Empty } from 'vant'
Vue.use(Popup).use(PullRefresh).use(Toast).use(Empty)
import { DateUtil } from '@/utils'

export default {
  data() {
    return {
      active: 0,
      fieldName: '',
      unionMatchId: '',
      columns: [],
      showSetTeam: false,
      teamIndexActive: 0,
      fieldId: '',
      gameDateList: [],
      dateName: '',
      list: [],
      teamList: [],
      setTeamObj: {
        id: '',
        stageId: '',
        homeTeamId: '',
        awayTeamId: '',
        matchId: '',
      },
      homeName: '',
      awayName: '',
      matchOptions: [],
      refreshing: false,
      type: '全部比赛', // 添加筛选类型
      typeList: [
        {name: '全部比赛'},
        {name: '已结束'},
        {name: '进行中'},
        {name: '未开始'},
      ]
    };
  },
  computed: {
    // 添加计算属性来过滤列表
    filteredList() {
      if (!this.list || this.list.length === 0) return []
      
      return this.list.filter(item => {
        if (this.type === '全部比赛') {
          return true
        } else if (item.fieldLiveRoomStatus === 3 && this.type === '已结束') {
          return true
        }  else if (item.fieldLiveRoomStatus < 0 && this.type === '未开始') {
          return true
        } else if (this.type === '进行中' && item.fieldLiveRoomStatus >= 0 && item.fieldLiveRoomStatus < 3) {
          return true
        } else {
          return false
        }
      })
    }
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.fieldId = this.$route.query.fieldId
    this.adminGetUnionMatchFields()
    this.getUnionMatchFieldGameDateList()
    this.adminGetBMUnionMatchGameList()
  },
  methods: {
    adminGetBMUnionMatchGameList() {
      adminGetBMUnionMatchGameList({ unionMatchId: this.unionMatchId }).then(res => {
        const { data } = res
        this.matchOptions = data.list
      })
    },
    adminGetUnionMatchFields() {
      adminGetUnionMatchFields({ unionMatchId: this.unionMatchId }).then(res => {
        const { data } = res
        this.columns = data.list
        this.fieldName = data.list.find(item => item.id == this.fieldId).name
      })
    },
    getUnionMatchFieldGameDateList() {
      getUnionMatchFieldGameDateList({ unionMatchId: this.unionMatchId, }).then(res => {
        const { data } = res
        this.gameDateList = data.list
        
        // 找到距离当前时间最近的未来日期
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()) // 今天的0点
        
        let nearestFutureDate = null
        let minDiff = Infinity
        
        this.gameDateList.forEach(item => {
          const itemDate = new Date(item.beginDate)
          const diff = itemDate.getTime() - today.getTime()
          
          // 只考虑未来的日期
          if (diff >= 0 && diff < minDiff) {
            minDiff = diff
            nearestFutureDate = item
          }
        })
        
        // 如果没有未来日期，使用第一个日期
        if (!nearestFutureDate && this.gameDateList.length > 0) {
          nearestFutureDate = this.gameDateList[0]
        }
        
        this.dateName = nearestFutureDate ? nearestFutureDate.beginDate : ''
        this.adminGetUnionMatchFieldGameList()
      })
    },
    adminGetUnionMatchFieldGameList() {
      adminGetUnionMatchFieldGameList({ unionMatchId: this.unionMatchId, fieldId: this.fieldId, date: this.dateName }).then(res => {
        const { data } = res
        this.list = data.list
      })
    },
    changeField(item) {
      this.fieldId = item.id
      this.fieldName = item.name
      this.adminGetUnionMatchFieldGameList()
    },
    changeDate(item) {
      this.dateName = item.beginDate
      this.adminGetUnionMatchFieldGameList()
    },
    changeActive(i) {
      if (this.active === i) {
        this.active = 0
        setTimeout(() => {
          this.$refs.overlay.style.display = 'none'
        }, 300)
      } else {
        this.$refs.overlay.style.display = 'block'
        setTimeout(() => {
          this.active = i
        },1)
      }
    },
    changeType(item) {
      this.type = item.name
      console.log('筛选类型:', this.type)
      console.log('筛选后数量:', this.filteredList.length)
    },
    getDate(value, type) {
      if (!value) return ''
      return DateUtil.parseDateTime(value, type)
    },
    setTeam(t, type) {
      if (t.is && t.id !== this.setTeamObj[type + 'TeamId']) {
        return
      }
      t.is = true
      if (type === 'home') {
        this.homeName = t.name
        this.setTeamObj.homeTeamId = t.id
      } else {
        this.awayName = t.name
        this.setTeamObj.awayTeamId = t.id
      }
       this.teamIndexActive = 0
    },
    cancelSetTeam() {
      this.showSetTeam = false
      this.teamList.forEach(item => {
        item.is = false
      })
      this.homeName = ''
      this.awayName = ''
      this.setTeamObj.homeTeamId = ''
      this.setTeamObj.awayTeamId = ''
      this.teamIndexActive = 0
      this.setTeamObj.id = ''
      this.setTeamObj.matchId = ''
      this.setTeamObj.stageId = ''
    },
    confirmSetTeam() {
      // this.showSetTeam = false
      // this.adminGetUnionMatchFieldGameList()
      adminUpdateBMMatchGame(this.setTeamObj).then(res => {
        if (res) {
          this.showSetTeam = false
          this.adminGetUnionMatchFieldGameList()
        }
      })
    },
    updateTeamIndex(i) {
      if (this.teamIndexActive === i) {
        this.teamIndexActive = 0;
      } else {
        this.teamIndexActive = i;
      }
      this.teamList.forEach(item => {
        if (item.id === this.setTeamObj.homeTeamId || item.id === this.setTeamObj.awayTeamId) {
          item.is = true
        } else {
          item.is = false
        }
      })
    },
    goDetail(item) {
      if (!(item.awayTeamName && item.homeTeamName)) {
        this.adminGetBMMatchStageTeamList(item.matchId, item.stageId)
        this.setTeamObj.id = item.id
        this.setTeamObj.matchId = item.matchId
        this.setTeamObj.stageId = item.stageId
      } else if (item.fieldLiveRoomStatus === 3) {
        Toast('比赛已结束')
      } else {
        this.$router.push({
          path: '/match-manage/scoring-table-detail/' + this.unionMatchId,
          query: {
            gameId: item.id
          }
        })
      }
    },
    adminGetBMMatchStageTeamList(matchId,stageId) {
      adminGetBMMatchStageTeamList({ matchId,stageId }).then(res => {
        const { data } = res
        this.teamList = data.teams.map(item => {
          return {
            id: item.id,
            name: item.name,
            is: false
          }
        })
        this.showSetTeam = true
      })
    },
    isDisabled(type, id) {
      const match = this.matchOptions.find(m => m.id === this.setTeamObj.id)
      if (!match) return
      const stage = match.stages.find(s => s.id == this.setTeamObj.stageId)
      if (stage.ruleType === '淘汰赛' || stage.ruleType === '自定义') return false
      if (type === 'home') {
        if (!this.setTeamObj.awayTeamId) {
          return false
        } else {
          const myGroup = this.teamList.find(team => team.id === id)
          const otherGroup = this.teamList.find(team => team.id === this.setTeamObj.awayTeamId)
          if (!myGroup || !otherGroup) return false
          return myGroup.groupId !== otherGroup.groupId
        }
      } else {
        if (!this.setTeamObj.homeTeamId) {
          return false
        } else {
          const myGroup = this.teamList.find(team => team.id === id)
          const otherGroup = this.teamList.find(team => team.id === this.setTeamObj.homeTeamId)
          if (!myGroup || !otherGroup) return false
          return myGroup.groupId !== otherGroup.groupId
        }
      }
    },
    onRefresh() {
      Promise.all([
        this.adminGetUnionMatchFieldGameList(),
        this.adminGetUnionMatchFields(),
        this.getUnionMatchFieldGameDateList()
      ]).then(() => {
        this.refreshing = false
      }).catch(() => {
        this.refreshing = false
      })
    }
  },
};
</script>

<style scoped lang="scss">
.scoring-table-list{
  background-color: #EBEBEB;
  min-height: 100vh;
  padding-top: 50px;
  .filter{
    .title{
      position: fixed;
      width: 100%;
      box-sizing: border-box;
      top: 0;
      z-index: 99;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 16px;
      background-color: #fff;
      font-size: 14px;
      height: 50px;
      font-weight: 500;
      box-shadow: 0 2px 12px rgba(100, 101, 102, 0.12);
      .play-icon{
        transform: rotate(90deg);
        transition: 0.3s ease;
      }
      .active{
        transform: rotate(-90deg);
      }
      
    }
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background-color: rgba($color: #000000, $alpha: 0);
      padding-top: 50px;
      z-index: 98;
      transition: 0.3s ease;
      display: none;
      &.bg-active{
        transition: 0.3s ease;
        background-color: rgba($color: #000000, $alpha: .4);
      }
      .overlay-list{
        height: 0px;
        overflow: auto;
        transition: 0.3s ease;
        // padding: 0 12px;
        &.list-active{
          height: 200px;
        }
        .overlay-item{
          border-bottom: 1px solid #ebedf0;
          background-color: #fff;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          width: 100%;
          padding: 0 24px;
          box-sizing: border-box;
          &.active{
            background-color: #EBF3FE;
            color: #0b69ec;
          }
        }
      }
    }
  }
  .list{
    padding: 6px;
    min-height: 80vh;
    .item{
      background-color: #fff;
      padding: 12px;
      border-radius: 6px;
      margin-bottom: 12px;
      font-size: 12px;
      .match-title{
        border-bottom: 1px solid #EBEBEB;
        padding-bottom: 6px;
      }
      .info{
        padding-top: 12px;
        .status{
          .time{
            width: 82px;
            color: #5f5f5f;
          }
          .status-text{
            color: #E49244;
            font-weight: 500;
            margin-top: 4px;
          }
        }
        .name{
          flex: 1;
          border-left: 1px solid #EBEBEB;
          padding-left: 12px;
          margin-left: 12px;
          div{
            margin-bottom: 4px;
          }
        }
        .score{
          padding-left: 12px;
          margin-left: 12px;
          div{
            margin-bottom: 4px;
          }
        }
      }
    }
  }
}
.set-match{
  .set-match-title{
    height: 50px;
    padding: 0 16px;
    .cancel{
      color: #5f5f5f;
    }
    .confirm{
      color: #0b69ec;
    }
  }
  .set-match-content{
    padding: 12px;
    height: 240px;
    align-items: flex-start;
    .input{
      position: relative;
      font-size: 14px;  
      border: 1px solid #dcdfe6; 
      flex: 1;
      border-radius: 5px;
      padding: 0 12px;
      height: 40px;
      transition: 0.3s ease;
      // &:hover{
      //   border-color: #0b69ec;
      //   .arrow-down{
      //     transform: rotate(180deg);
      //   }
      // }
      .input-list{
        position: absolute;
        top: 50px;
        left: 0;
        width: 100%;
        background-color: #fff;
        height: 0px;
        overflow: hidden;
        
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        border-radius: 4px;
        transition: 0.3s ease;
        box-sizing: border-box;
        .input-item{
          padding: 0 12px;
          height: 40px;
          line-height: 40px;
          &:active {
            background-color: #f5f7fa;
          }
          &.active{
            background-color: #EBF3FE;
            color: #0b69ec;
          }
          &.disabled{
            color: #5f5f5f;
            background-color: #f5f7fa;
          }
        }
      }
      .list-active{
        border:1px solid #e4e7ed;
        height: 160px;
        overflow: auto;
      }
    }
    .vs{
      width: 20px;
      font-size: 14px;
      color: #5f5f5f;
      margin: 0 12px;
      margin-top: 12px;
    }
  }
}
</style>
